module.exports = __webpack_public_path__ + "static/img/pp5.6d2ae6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/pp5.png
// module id = 4LFm
// module chunks = 0